import React from "react";
import "./style/Discover.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThLarge } from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";

function Discover() {
  return (
    <div className="discover">
      <h2>Discover</h2>
      <ul>
        <NavLink exact to="/" activeClassName="active">
          <li>
            <FontAwesomeIcon icon={faThLarge} /> <p>Home</p>
          </li>
        </NavLink>
        <NavLink to="/ForYou">
          <li>
            <FontAwesomeIcon icon={faHeart} /> <p>For you</p>
          </li>
        </NavLink>
        <NavLink to="/Browse">
          <li>
            <FontAwesomeIcon icon={faSearch} /> <p>Browse</p>
          </li>
        </NavLink>
      </ul>
    </div>
  );
}

export default Discover;
